/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * It\'s identifier of the type of the answer as well as presentation details
 * @export
 * @enum {string}
 */

export const ScaleAnswerTypeDto = {
    Left: 'LEFT',
    Center: 'CENTER',
    Right: 'RIGHT'
} as const;

export type ScaleAnswerTypeDto = typeof ScaleAnswerTypeDto[keyof typeof ScaleAnswerTypeDto];



